import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule } from '@angular/router';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './+shared/modules/core.module';
import { CookieService } from 'ngx-cookie-service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromNotificationReducer from '../../../shared/reducers/notification.reducer';
import * as fromUserReducer from '../../../shared/reducers/user.reducer';
// import * as fromCategoryReducer from '../../../shared/reducers/category/category.reducer';
// import * as fromSubCategoryReducer from '../../../shared/reducers/category/sub-category.reducer';
import * as fromWalletReducer from '../../../shared/reducers/wallet.reducer';
import * as fromProductReducer from '../../../shared/reducers/product.reducer';
import * as fromCartReducer from '../../../shared/reducers/cart.reducer';
import * as fromTicketSystemReducer from '../../../shared/reducers/ticket-system.reducer';
import { CartEffects } from '../../../shared/effects/cart.effect';
import { UserEffects } from '../../../shared/effects/user.effect';
// import { CategoryEffects } from '../../../shared/effects/category.effect';
import { CheckoutEffects } from '../../../shared/effects/checkout.effect';
import { WalletEffects } from 'projects/shared/effects/wallet.effect';
import { ProductEffects } from 'projects/shared/effects/product.effect';
import { NotificationEffects } from 'projects/shared/effects/notification.effect';
import { TicketSystemEffects } from 'projects/shared/effects/ticket-system.effect';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { DevAccessInterceptor } from 'projects/shared/interceptor/access-key.interceptor';
import { LayoutsModule } from './layout/layouts.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MobileToaster } from './../../../shared/components/mobile-toaster/mobile-toaster.component';
import { IpService } from './+shared/services/user-ip.service';
import { SentryInterceptor } from './../../../shared/interceptor/sentry.interceptor';
import * as Sentry from "@sentry/angular";
import { SessionExpiredInterceptor } from './../../../shared/interceptor/session-expired.interceptor';
import { NavigateToDirective } from 'projects/shared/directives/navigator.directive';
import { OtpInputComponent } from "projects/shared/components/OTP/otp-input.component";
import { UploadAreaComponent } from '../../../shared/components/upload-area/upload-area.component';
import { CredentialsInterceptor } from 'projects/shared/interceptor/credentials.interceptor';
import { NetworkRetryInterceptor } from 'projects/shared/interceptor/network-retry.interceptor';
import { transferStateInterceptor } from 'projects/shared/interceptors/transfer-state.interceptor';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    LayoutsModule,
    MobileToaster,
    NavigateToDirective,
    EffectsModule.forFeature([
      UserEffects,
      // CategoryEffects,
      WalletEffects,
      ProductEffects,
      NotificationEffects,
      CartEffects,
      TicketSystemEffects,
      CheckoutEffects,
      // DialogModule
    ]),
    EffectsModule.forRoot(),
    StoreModule.forRoot({}),
    StoreModule.forFeature(fromNotificationReducer.notificationFeatureKey, fromNotificationReducer.reducer),
    StoreModule.forFeature(fromUserReducer.usersFeatureKey, fromUserReducer.reducer),
    StoreModule.forFeature(fromWalletReducer.walletFeatureKey, fromWalletReducer.reducer),
    StoreModule.forFeature(fromProductReducer.productsFeatureKey, fromProductReducer.reducer),
    StoreModule.forFeature(fromCartReducer.cartFeatureKey, fromCartReducer.reducer),
    StoreModule.forFeature(fromTicketSystemReducer.ticketSystemFeatureKey, fromTicketSystemReducer.reducer),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    OtpInputComponent
  ],
  providers: [
    CookieService,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    provideHttpClient(withInterceptors([
      transferStateInterceptor, // Must be first to cache requests
      NetworkRetryInterceptor,
      DevAccessInterceptor,
      CredentialsInterceptor,
      SessionExpiredInterceptor,
      SentryInterceptor
    ])),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi() // ✅ عشان الـ HTTP_INTERCEPTORS يشتغل
    ),

  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
export function appInitializerFactory(
  translate: TranslateService,
): () => Promise<void> {
  return () =>
    new Promise((resolve) => {
      translate.setDefaultLang('en');
      translate.use('en').subscribe(() => {
        resolve();
      });
    });
}
